import { useLocaliseString } from '@hooks/useLocaliseString'

type HamburgerProps = {
  isNavOpen: boolean
  toggleNavOpen: () => void
}

export const Hamburger = ({ isNavOpen, toggleNavOpen }: HamburgerProps) => {
  const localiseString = useLocaliseString()

  return (
    <button
      onClick={toggleNavOpen}
      aria-label={localiseString('hamburgerMenu')}
    >
      <svg xmlns='http://www.w3.org/2000/svg' width='26' height='26'>
        <rect
          x='0'
          y='12'
          width='26'
          height='2'
          className={`dark:fill-white transition-all duration-300 ease-in-out overflow-visible transform origin-center ${
            isNavOpen ? '-rotate-45' : 'translate-y-[10px]'
          }`}
        />
        <rect
          x='0'
          y='12'
          width='26'
          height='2'
          className={`dark:fill-white transition-all duration-300 ease-in-out ${
            isNavOpen ? 'opacity-0' : ''
          }`}
        />
        <rect
          x='0'
          y='12'
          width='26'
          height='2'
          className={`dark:fill-white transition-all duration-300 ease-in-out overflow-visible transform origin-center ${
            isNavOpen ? 'rotate-45' : '-translate-y-[10px]'
          }`}
        />
      </svg>
    </button>
  )
}
